import * as Net from 'util/Net';

export type AvScanStatus =
  | 'PENDING'
  | 'NO_THREATS_FOUND'
  | 'THREATS_FOUND'
  | 'UNSUPPORTED'
  | 'ACCESS_DENIED'
  | 'FAILED'
  | 'NEVER_SCANNED';

export const AV_SCAN_TERMINAL_STATUSES: ReadonlySet<AvScanStatus> = new Set([
  'THREATS_FOUND',
  'NO_THREATS_FOUND',
  'UNSUPPORTED',
  'ACCESS_DENIED',
  'FAILED',
  'NEVER_SCANNED',
]);

export interface AvScanStatusResponse {
  scanId: string;
  sourceId: string;
  scanStatus: AvScanStatus;
  createdAt: string;
  errorMessage?: string;
}

export function getScanStatus(scanId: string): Promise<AvScanStatusResponse> {
  return Net.getJSONPromise(`/1/api/av-scan/${scanId}/status`);
}
